<script lang="ts">
export default { name: 'FeatureDetailsBlock' };
</script>

<script setup lang="ts">
import { computed } from 'vue';

/**
 * `FeatureDetailsBlock` component properties.
 */
export interface Props {
  title: string;
  details: string;
  justification: 'left' | 'right';
}

const props = defineProps<Props>();

const classList = computed(() => {
  const classList: string[] = ['feature-details-block'];

  if (props.justification === 'left') {
    classList.push('justified-left');
  } else {
    classList.push('justified-right');
  }

  return classList;
});
</script>

<template>
  <div :class="classList">
    <div class="subtitle">FEATURES</div>
    <h2 class="mb-4">{{ title }}</h2>
    <p>{{ details }}</p>

    <div>
      <b-button variant="alt-primary" :to="{ name: 'individuals' }">
        Buy
      </b-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.feature-details-block {
  color: #fff;
  width: 100%;
  max-width: 475px;
  z-index: 1;

  &.justified-left {
    text-align: left;
  }

  &.justified-right {
    text-align: right;
  }

  @include app-mobile {
    // max-width: none;
    text-align: center;
  }
}

h2 {
  color: inherit;
  font-weight: 500;

  @include app-mobile {
    font-size: 1.25rem;
  }
}

.subtitle {
  font-size: 1.13rem;
  font-weight: 500;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 5px;

  @include app-mobile {
    // font-size: 1.5rem;
    font-size: 1rem;
  }
}

.btn {
  //   border: none;
  //   color: #082e44;
  //   background: #f0d949;
  font-weight: 500;
  padding: 0.375rem 2.75rem;
}

a.block-cta {
  color: #f0d949;
  display: inline-flex;
  align-items: center;

  .fa-icon {
    margin-left: 0.5rem;
    font-size: 0.8rem;
  }
}
</style>
